import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.to-string.js";
import { gtmPushEvent } from '~/helpers/gtm';
import { useLocalization } from '~/composables/_next/useLocalization';
var _getToken = function _getToken(locale) {
  var tokens = {
    fr: process.env.ATTRAQT_KEY_FR,
    it: process.env.ATTRAQT_KEY_IT,
    de: process.env.ATTRAQT_KEY_DE,
    es: process.env.ATTRAQT_KEY_ES,
    en: process.env.ATTRAQT_KEY_EN
  };
  return tokens[locale] || tokens.fr;
};
var _getUpsellToken = function _getUpsellToken(locale) {
  var tokens = {
    fr: process.env.UP_SELL_FR,
    it: process.env.UP_SELL_IT,
    es: process.env.UP_SELL_ES,
    de: process.env.UP_SELL_DE,
    en: process.env.UP_SELL_EN
  };
  return tokens[locale] || tokens.fr;
};
var getUpsellTokenProductPage = function getUpsellTokenProductPage(locale) {
  var _tokens$locale;
  var tokens = {
    fr: process.env.ATTRAQT_KEY_FR_PRODUCT_PAGE,
    it: process.env.ATTRAQT_KEY_IT_PRODUCT_PAGE,
    de: process.env.ATTRAQT_KEY_DE_PRODUCT_PAGE,
    en: process.env.ATTRAQT_KEY_EN_PRODUCT_PAGE,
    es: process.env.ATTRAQT_KEY_ES_PRODUCT_PAGE
  };
  return (_tokens$locale = tokens[locale]) !== null && _tokens$locale !== void 0 ? _tokens$locale : tokens.fr;
};
var useUpsellProducts = function useUpsellProducts() {
  var loading = ref(false);
  var result = ref(null);
  var _useLocalization = useLocalization(),
    locale = _useLocalization.locale;
  function get() {
    return _get.apply(this, arguments);
  }
  function _get() {
    _get = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var basketItemsSkus,
        id,
        apiUrl,
        sessionId,
        variableQuery,
        _variableQuery,
        _args = arguments;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            basketItemsSkus = _args.length > 0 && _args[0] !== undefined ? _args[0] : [];
            id = _args.length > 1 ? _args[1] : undefined;
            if (id) {
              apiUrl = "https://api.early-birds.io/widget/".concat(id, "/recommendations");
            } else {
              apiUrl = "https://api.early-birds.io/widget/".concat(_getUpsellToken(locale), "/recommendations");
            }
            sessionId = localStorage.getItem('attraqtsessionid');
            if (sessionId) {
              apiUrl = "".concat(apiUrl, "/sessionId/").concat(sessionId);
            }
            if (basketItemsSkus.length > 1) {
              variableQuery = "variables={\"$basketId\": [\"".concat(basketItemsSkus.join('","'), "\"]}");
              apiUrl = "".concat(apiUrl, "?").concat(variableQuery);
            } else {
              _variableQuery = "variables={\"$productid\": \"".concat(basketItemsSkus[0], "\"}");
              apiUrl = "".concat(apiUrl, "?").concat(_variableQuery);
            }
            loading.value = true;
            _context.next = 9;
            return $fetch(apiUrl);
          case 9:
            result.value = _context.sent;
            // this code allows you to use the attraqt extension on chrome,
            // to get live details of the widjet used for the recommendation.
            //! !do not delete the next two lines!!

            window.ebRecoIds = window.ebRecoIds || [];
            window.ebRecoIds.push(result.value.id);
            loading.value = false;
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _get.apply(this, arguments);
  }
  function getWidgetId() {
    return _getUpsellToken(locale);
  }
  function sendUpsellClick(product, recommendationid, widgetId, index) {
    gtmPushEvent('upsell_click', {
      event_category: 'upsell',
      event_action: 'click',
      event_label: product.name,
      event_name: 'upsell_click',
      source_id: recommendationid,
      widget_id: widgetId,
      index: index,
      product_sku: product.sku
    });
  }
  return {
    loading: loading,
    get: get,
    result: result,
    sendUpsellClick: sendUpsellClick,
    getWidgetId: getWidgetId,
    getUpsellTokenProductPage: getUpsellTokenProductPage
  };
};
var useAttraqtSearch = function useAttraqtSearch(id) {
  var router = useRouter();
  var ssrKey = id || 'useAttraqtSearch';
  var result = useState("".concat(ssrKey, "-attraqt"), function () {
    return {
      data: null,
      input: null
    };
  });
  var loading = useState("".concat(ssrKey, "-loading-attraqt"), function () {
    return false;
  });
  var _useLocalization2 = useLocalization(),
    locale = _useLocalization2.locale;
  function search(_x) {
    return _search.apply(this, arguments);
  }
  function _search() {
    _search = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(params) {
      var _result$value, _result$value$data, _result$value$data$it, _result$value$data$it2, _result$value$data$it3;
      var token, input, response, message;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            loading.value = true;
            token = _getToken(locale);
            input = _objectSpread(_objectSpread({}, params), {}, {
              token: token
            });
            result.value.input = input;
            result.value.data = null;
            _context2.next = 7;
            return fetch("".concat(process.env.ATTRAQT_API_URL, "/search"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(input),
              redirect: 'follow'
            });
          case 7:
            response = _context2.sent;
            _context2.next = 10;
            return response.json();
          case 10:
            result.value.data = _context2.sent;
            if (!response.ok) {
              message = "An error has occured during request to Attraqt: ".concat(response.status, " - ").concat(response.statusText);
              console.error(message);
            }
            if ((_result$value = result.value) !== null && _result$value !== void 0 && (_result$value$data = _result$value.data) !== null && _result$value$data !== void 0 && (_result$value$data$it = _result$value$data.items) !== null && _result$value$data$it !== void 0 && (_result$value$data$it2 = _result$value$data$it[0]) !== null && _result$value$data$it2 !== void 0 && (_result$value$data$it3 = _result$value$data$it2.redirect) !== null && _result$value$data$it3 !== void 0 && _result$value$data$it3.url) {
              router.push(result.value.data.items[0].redirect.url);
            }
            loading.value = false;
          case 14:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _search.apply(this, arguments);
  }
  return {
    result: computed(function () {
      return result.value;
    }),
    search: search,
    loading: loading
  };
};
var getItems = function getItems(searchData) {
  var _searchData$data;
  var productsData = searchData === null || searchData === void 0 ? void 0 : (_searchData$data = searchData.data) === null || _searchData$data === void 0 ? void 0 : _searchData$data.items;
  return productsData || [];
};
var getPrice = function getPrice(product) {
  var _product$product;
  var productPrice = (_product$product = product.product) === null || _product$product === void 0 ? void 0 : _product$product.price;
  if (productPrice) {
    return +productPrice / 100;
  }
  return 0;
};
var getCoverImage = function getCoverImage(product) {
  var _product$product2;
  return ((_product$product2 = product.product) === null || _product$product2 === void 0 ? void 0 : _product$product2.photo) || '';
};
var getName = function getName(product) {
  var _product$product3, _product$product3$l, _product$product3$l$m, _product$product4;
  var _useLocalization3 = useLocalization(),
    locale = _useLocalization3.locale;
  var mappedLocale = "".concat(locale, "_").concat(locale.toUpperCase());
  var productName = (_product$product3 = product.product) === null || _product$product3 === void 0 ? void 0 : (_product$product3$l = _product$product3.l10n) === null || _product$product3$l === void 0 ? void 0 : (_product$product3$l$m = _product$product3$l[mappedLocale]) === null || _product$product3$l$m === void 0 ? void 0 : _product$product3$l$m.name;
  return productName || ((_product$product4 = product.product) === null || _product$product4 === void 0 ? void 0 : _product$product4.title) || '';
};
var getSlug = function getSlug(product) {
  var _product$product5;
  return ((_product$product5 = product.product) === null || _product$product5 === void 0 ? void 0 : _product$product5.url) || '';
};
var getCategories = function getCategories(product) {
  var _product$product6;
  return ((_product$product6 = product.product) === null || _product$product6 === void 0 ? void 0 : _product$product6.categoryNames) || [];
};
var getCategory = function getCategory(product) {
  var _product$product7;
  return (_product$product7 = product.product) === null || _product$product7 === void 0 ? void 0 : _product$product7.mainCategory;
};
var attraqtGetters = {
  getItems: getItems,
  getPrice: getPrice,
  getCoverImage: getCoverImage,
  getName: getName,
  getSlug: getSlug,
  getCategories: getCategories,
  getCategory: getCategory
};
export { useAttraqtSearch, attraqtGetters, useUpsellProducts };